import { useScrollToTop } from 'expo-router';
import React, { Fragment, useRef } from 'react';
import { Animated, View } from 'react-native';
import  {
  MARGIN_FN,
  MARGIN_HORIZONTAL_DASHBOARD_ITEM,
  PADDING_LEFT_DASHBOARD,
  WIDTH_ACTIVITY_FN,
  WIDTH_PATH_FN,
  isWeb,
} from '../../config/designSystem/Layout';

import Show from '../Show/Show';
import { ContentSectionTitle } from './ContentSectionTitle';
import { HorizontalItem, HorizontalItemContentType } from './HorizontalItem';
import { observer } from 'mobx-react';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';



export type ContentSectionItem = {
  _id: string;
  contentType: HorizontalItemContentType;
  order: number;
  contentId: string;
  showActivityType?: boolean | null;
};

type ContentSectionProps = {
  data: [ContentSectionItem];
  id?: string;
  filterOutId?: string;
  showAll?: boolean;
  displayButtonBelow?: boolean;
  withTitle?: boolean;
};



export const ContentSection = observer(({ data,  id, filterOutId, showAll,displayButtonBelow ,withTitle = true}: ContentSectionProps) => {
  const scrollRef = useRef<Animated.FlatList | null>(null);
  const { width } = useAvailableDimensions();
  useScrollToTop(scrollRef);



  const dataWithFilter = data.filter((d: ContentSectionItem) => d.contentId !== filterOutId && (!displayButtonBelow || d.contentType === 'PATH'));
  const snaps = [0];
  dataWithFilter.forEach(it => {
    if(it.contentType === 'PATH') {
      snaps.push(snaps[snaps.length - 1] + WIDTH_PATH_FN(width) + 2 * MARGIN_HORIZONTAL_DASHBOARD_ITEM(width));
    } else {
      snaps.push(snaps[snaps.length - 1] + WIDTH_ACTIVITY_FN(width) + 2 * MARGIN_HORIZONTAL_DASHBOARD_ITEM(width));
    }
  });
  const SHOW_ALL = !!showAll && !isWeb && dataWithFilter.length > 4;
  let dataForWeb = dataWithFilter;
  let maxRow = 1;

  const MARGIN = 5 * MARGIN_FN(width);
  if (isWeb) {
    let lastIndex = 0;
    let lastRow = 0;
    const dataCopy = dataWithFilter.map((item, index) => {
      const snapsInterval = snaps[index + 1] - snaps[lastIndex];
      if (snapsInterval + MARGIN > width && index !== lastIndex) {
        lastRow = lastRow + 1;
        lastIndex = index;
      }
      return { ...item, row: lastRow };
    }, []);
    dataForWeb = dataCopy;
    maxRow = Math.max(...dataCopy.map(d => d.row));
  }




  const scrollToIndexFailed = (error: any) => {
    const offset = error.averageItemLength * error.index;
    scrollRef.scrollToOffset({ offset });
  };






  const renderRow = (dataRow: any, key: string) => {

    return (
      <View style={{ flexDirection: 'row', marginBottom: 50}} key={key}>
        {dataRow.map((dr: any, index: number) => {
          return (
            <Fragment key={index}>
              <HorizontalItem
                small= {false}
                id={dr.contentId}
                contentType={dr.contentType}
                key={dr?._id}
                displayButtonBelow={!!displayButtonBelow}
                showActivityType={dr.showActivityType}
              />
            </Fragment>
          );
        })}
      </View>
    );
  };

  const renderWeb = (dataCopy: any) => {
    const reactNodes: React.ReactNode[] = [];
    for (let i = 0; i <= maxRow; i++) {
      const dataRow = dataCopy.filter((dc: any) => dc.row === i);
      reactNodes.push(renderRow(dataRow, `${i}`));
    }
    return <View style={{ marginLeft: 2 * MARGIN_FN(width) }}>{reactNodes.filter(x => x).flatMap(x => x)}</View>;
  };

  const renderMobile = () => {
    return ( <Animated.FlatList
      data={dataWithFilter}
      keyExtractor={(data, index) => (data?._id? data._id : String(index))}
      horizontal
      bounces={false}
      ref={scrollRef}
      onScrollToIndexFailed={scrollToIndexFailed}
      snapToOffsets={snaps}
      decelerationRate="fast"
      renderItem={({ item,index }) => (
        <Fragment key={index}>
          <HorizontalItem
            id={item.contentId}
            small={false}
            contentType={item.contentType}
            displayButtonBelow={!!displayButtonBelow}
            showActivityType={item.showActivityType}
          />
        </Fragment>
      )}
      showsHorizontalScrollIndicator={false}
      scrollEventThrottle={16}
      contentContainerStyle={{
        paddingLeft: PADDING_LEFT_DASHBOARD(width),
      }}
    />);
  };

  return (
    <>
      <Show when={dataWithFilter.length>0 && withTitle}>

        <ContentSectionTitle categoryId={id} displayAll={SHOW_ALL}/>
      </Show>
      { isWeb ? (
        renderWeb(dataForWeb)
      ) : (
        renderMobile()
      )}
    </>
  );
});

